/* istanbul ignore file */

import slugify from './slugify';

export default slugify;
